// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"061b4c6d","239":"3bde880a","453":"f3fcab28","553":"2668b5eb","692":"ea6fb721","867":"4f5bf24d"}[chunkId] + ".chunk.js";
};